import { render, staticRenderFns } from "./bulk-payment-history-view.vue?vue&type=template&id=10ffcddf&scoped=true"
import script from "./bulk-payment-history-view.vue?vue&type=script&lang=js"
export * from "./bulk-payment-history-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ffcddf",
  null
  
)

export default component.exports